import 'css-chunk:src/app/containers/Home/CommunitiesView/CommunityDetailView.scss';export default {
  "CommunityDetailView": "_CommunityDetailView_1txej_2",
  "header": "_header_1txej_2",
  "action": "_action_1txej_7",
  "children": "_children_1txej_10",
  "menu": "_menu_1txej_10"
};